import type { FC } from 'react';
import { Route } from 'react-router-dom';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { HydrogenOperatorBookingDetails } from 'src/pages/h2/fcfs/operator-bookings/details';
import { HydrogenOperatorBookingOverview } from 'src/pages/h2/fcfs/operator-bookings/overview';

export const HydrogenOperatorBookings: FC = () => {
  return (
    <RootRoutes>
      <Route
        path="/h2/fcfs/operator-bookings"
        element={<HydrogenOperatorBookingOverview />}
      />
      <Route
        path="/h2/fcfs/operator-bookings/:bookingProcessId"
        element={<HydrogenOperatorBookingDetails />}
      />
      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
